// extracted by mini-css-extract-plugin
export default {"box":"advertisementFilterPage_box__LrZAs","box__content":"advertisementFilterPage_box__content__aj1sT","box__btn":"advertisementFilterPage_box__btn__C+Fh-"};